
import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import trainingsAPI from "../../../services/trainings";
import { Button } from "primereact/button";
import MeaDataTable from "../../../components/MeaDataTable";
import { Column } from "primereact/column";
import campaignsAPI from "../../../services/campaigns";
import MeaLink from "../../../components/MeaLink";

const RegistrationCampaignsPage = () => {

  //
  const toast = useRef();
  //
  const navigate = useNavigate();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const registrationId = params.registrationId;
  const accessToken = "";

  const campaignsQuery = campaignsAPI.useGetList(schoolId, registrationId, accessToken, 1, 100);
  const campaigns = campaignsQuery?.data?.data;
  //
  return (
    <>
      <MeaPage title="Campagnes d'e-mails" showBackButton={false}>
        <div className="card">
          <div className="flex justify-content-start gap-2">
            <Button className="p-button p-button-primary mb-3" onClick={() => { navigate("/school/" + schoolId + "/admin/registrations/" + registrationId + "/campaigns-new") }}>
              <i className="pi pi-envelope mr-2"></i>
              Nouvelle campagne
            </Button>
          </div>
        </div>
        <MeaDataTable query={campaignsQuery} serviceAPI={campaignsAPI} showDeleteButton={false} schoolId={schoolId}>
          <Column
            field="created_at"
            header="Date"
            body={(item) => {
              return item?.created_at ? new Date(item?.created_at).toLocaleDateString("fr-FR") : "-";
            }}
          ></Column>
          <Column field="subject" header="Objet" body={(item) => {
            return <MeaLink to={`/school/${schoolId}/admin/registrations/${registrationId}/campaigns/${item.id}`}>{item.subject}</MeaLink>;
          }} />
          <Column field="recipients_lists" header="Destinataires" body={(item) => {
            return item?.recipients_lists?.split(",").map((recipient) => {
              switch (recipient.trim()) {
                case "PREREGISTRED":
                  return "Pré-inscrits";
                case "ENROLLED":
                  return "Inscrits";
                case "UNREGISTRED":
                  return "Désincrits";
                case "WAITING_LIST":
                  return "Liste d'attente";
                case "NEW":
                  return "Nouveaux dossiers";
                case "PERSONALIZED":
                  return "Personnalisé";
                case "TEACHERS":
                  return "Enseignants";
                case "SECRETARIES":
                  return "Secrétaires";
                case "ADMINISTRATORS":
                  return "Équipe administrative";
              }
            }).join(", ");
          }} />
          <Column field="dry_run" header="Mode de test" body={(item) => {
            return item?.dry_run ? <i className="pi pi-check" style={{ color: "green" }}></i> : <></>;
          }} />

          <Column field="status" header="Statut" body={(item) => {
            switch (item?.status) {
              case "SENT":
                return "Envoyée";
              case "FAILED":
                return "Erreur";
              case "PENDING":
              default:
                return "En cours d'envoi";
            }
          }} />
        </MeaDataTable>
      </MeaPage>
    </>
  );
};
export default RegistrationCampaignsPage;
